<script setup lang="ts">
import LegalTerms from '@/domains/-legal/components/LegalTerms.vue';
import { odsBox } from 'omind-design-system/components/odsBox';
import { odsButton } from 'omind-design-system/components/odsButton';
import { closePopup } from 'omind-design-system/components/odsPopup';
import { FlexDirection, Spacing } from 'omind-design-system/tokens';

</script>

<template>
    <odsBox :direction="FlexDirection.Column" :padding="Spacing.None" :gap="Spacing.Large">
        <LegalTerms></LegalTerms>
        <odsButton :label="$t('lexicon.close')" @click="closePopup('popup-legal')"></odsButton>
    </odsBox>
</template>

<style lang="scss"></style>